{
    "counters": {
        "u_column": 2,
        "u_row": 2,
        "u_content_custom_lev-unsubscribe-footer": 3
    },
    "body": {
        "rows": [
            {
                "cells": [
                    1
                ],
                "columns": [
                    {
                        "contents": [],
                        "values": {
                            "backgroundColor": "",
                            "padding": "0px",
                            "border": {},
                            "_meta": {
                                "htmlID": "u_column_2",
                                "htmlClassNames": "u_column"
                            }
                        }
                    }
                ],
                "values": {
                    "displayCondition": null,
                    "columns": false,
                    "backgroundColor": "",
                    "columnsBackgroundColor": "",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": false,
                        "center": true,
                        "cover": false
                    },
                    "padding": "0px",
                    "hideDesktop": false,
                    "hideMobile": false,
                    "noStackMobile": false,
                    "_meta": {
                        "htmlID": "u_row_2",
                        "htmlClassNames": "u_row"
                    },
                    "selectable": true,
                    "draggable": true,
                    "duplicatable": true,
                    "deletable": true
                }
            },
            {
                "cells": [
                    1
                ],
                "columns": [
                    {
                        "contents": [
                            {
                                "type": "custom",
                                "slug": "lev-unsubscribe-footer",
                                "values": {
                                    "containerPadding": "10px",
                                    "_meta": {
                                        "htmlID": "u_content_custom_lev-unsubscribe-footer_3",
                                        "htmlClassNames": "u_content_custom_lev-unsubscribe-footer"
                                    },
                                    "selectable": true,
                                    "draggable": false,
                                    "duplicatable": false,
                                    "deletable": false,
                                    "hideable": false,
                                    "fontFamily": {
                                        "label": "Arial",
                                        "value": "arial,helvetica,sans-serif"
                                    },
                                    "size": "14",
                                    "textAlign": "center",
                                    "textColor": "#0D0F11",
                                    "hideDesktop": false,
                                    "hideMobile": false
                                }
                            }
                        ],
                        "values": {
                            "backgroundColor": "",
                            "padding": "0px",
                            "border": {},
                            "_meta": {
                                "htmlID": "u_column_1",
                                "htmlClassNames": "u_column"
                            }
                        }
                    }
                ],
                "values": {
                    "displayCondition": null,
                    "columns": false,
                    "backgroundColor": "",
                    "columnsBackgroundColor": "",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": false,
                        "center": true,
                        "cover": false
                    },
                    "padding": "0px",
                    "hideDesktop": false,
                    "hideMobile": false,
                    "noStackMobile": false,
                    "_meta": {
                        "htmlID": "u_row_1",
                        "htmlClassNames": "u_row"
                    },
                    "selectable": false,
                    "draggable": false,
                    "duplicatable": false,
                    "deletable": false,
                    "hideable": false
                }
            }
        ],
        "values": {
            "backgroundColor": "",
            "backgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": false,
                "center": true,
                "cover": false
            },
            "contentWidth": "500px",
            "contentAlign": "center",
            "fontFamily": {
                "label": "Arial",
                "value": "arial,helvetica,sans-serif"
            },
            "preheaderText": "",
            "linkStyle": {
                "body": true,
                "linkColor": "#0000ee",
                "linkHoverColor": "#0000ee",
                "linkUnderline": true,
                "linkHoverUnderline": true
            },
            "_meta": {
                "htmlID": "u_body",
                "htmlClassNames": "u_body"
            }
        }
    },
    "schemaVersion": 5
}